export const CLEAR_AGENTS_STATE = "CLEAR_AGENTS_STATE";

export const SET_AGENTS_SUCCESS = "SET_AGENTS_SUCCESS";
export const SET_AGENTS_ERROR = "SET_AGENTS_ERROR";

export const TOGGLE_FETCHING_AGENTS = "TOGGLE_FETCHING_AGENTS";
export const SET_AGENTS = "SET_AGENTS";

export const SET_SELECTED_AGENT = "SET_SELECTED_AGENT";
